var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGilock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18457 1.33789V4.47753C9.18457 5.77933 10.2386 6.83339 11.5404 6.83339H16.6395",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6395 9.57663C18.1846 9.57663 19.4323 8.30185 19.3828 6.7478C19.3377 5.2433 18.0269 4.08564 16.5224 4.08564H13.8332C12.8512 4.08564 12.3242 3.55861 12.3242 2.90996V1.33789",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2481 15.0684H4.08594",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2207 9.57617H19.7748C21.2928 9.57617 22.5225 10.8059 22.5225 12.3239C22.5225 12.7428 22.4279 13.1437 22.2567 13.4996",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2204 12.3236C5.70239 12.3236 4.47266 11.0939 4.47266 9.57587C4.47266 8.05786 5.70239 6.82812 7.2204 6.82812H12.7114",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 12.3242H4.08564C2.56762 12.3242 1.33789 13.5539 1.33789 15.072C1.33789 16.59 2.56762 17.8197 4.08564 17.8197H13.8919",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3243 25.6622V22.9145C12.3243 21.6126 11.2703 20.5586 9.96845 20.5586H7.2207",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22123 17.8145C5.67619 17.8145 4.42844 19.0892 4.47799 20.6433C4.52303 22.1478 5.83384 23.3054 7.33835 23.3054H7.90592C8.65817 23.3054 9.1852 23.8325 9.1852 24.4811V25.6568",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.108 20.5625H9.18457",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5765 19.636C25.6305 19.9378 25.6621 20.2486 25.6621 20.5639C25.6621 23.3793 23.3783 25.663 20.563 25.663C17.7477 25.663 15.4639 23.3793 15.4639 20.5639C15.4639 17.7486 17.7477 15.4648 20.563 15.4648C21.0449 15.4648 21.5134 15.5324 21.9549 15.6585",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 20.0984L20.5629 21.9543L25.198 16.3867",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGilock);
export default __webpack_public_path__ + "static/media/gilock.cc1e8f4538d1fb9e6daaefe9e6f81f3e.svg";
export { ForwardRef as ReactComponent };